import React, {Component} from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';
import Router from './Router';
import {USER_SUCCESS, USER_FAILED, USER_NO_PERMISSION} from '../../redux/actions/UserActions'
import {fetchUserDataIfNeeded} from '../../redux/actions/UserActions'
import {fetchUtilsDataIfNeeded} from '../../redux/actions/UtilsActions'
import LoadingProgress from '../../components/LoadingProgress'
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import RouterSignUp from './RouterSignUp';
import {fetchCustomeraDataIfNeeded} from "../../redux/actions/CustomersActions";
import {fetchSalesDataIfNeeded} from "../../redux/actions/SalesActions";
import * as http from "../../modules/http";
import * as environment from "../../modules/environment";
import ModalTrueBigProp from "../../../src/components/ModalTrueBigProp"


const managersForNotify = [{id:19, name: "maor"}, {id:39, name:"ישראל"}, {id:65, name: "מושיקו"}, {id:106, name: "עקיבא פאלק"}, {id:114, name:"man3"}];

class App extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            loaded: true,
            timerLoaded: false,
            timerLoaded2: false,
            timerLoaded3: false,
            newCustomers: ''
        };
    }

    componentDidMount() {
        this.props.dispatch(fetchUserDataIfNeeded());
        this.props.dispatch(fetchUtilsDataIfNeeded());
        this.props.dispatch(fetchCustomeraDataIfNeeded({}));
        this.props.dispatch(fetchSalesDataIfNeeded());
    }

    checkTasks = () => {
        http.postToServer(
            'tasks/count',
            {},
            (response) => {
                if(response.data.count > 0) {
                    alert("שימו לב, יש לכם " + response.data.count + " משימות פתוחות לטפל..\n" + "נא טיפולכם המהיר!!!");
                }

            },
            (response) => {
                console.log('error checkTasks App');
            }
        );
    };

    checkPrize = () => {
        if(this.props.userData && this.props.userData.data) {
            http.postToServer(
                'prize/check?id=' + this.props.userData.data.id,
                {},
                (response) => {
                    if(response.data.prize !== "") {
                        if(response.data.shouldSale !== 0) {
                            alert("שימו לב, יש לכם " + response.data.shouldSale + " למכירה כדי לקבל פרס..\n");
                        }

                        if(response.data.isGoalReached === true) {
                            alert("BINGO!!!");
                        }
                    }
                    //console.log(response.data)
                },
                (response) => {
                    console.log('error checkPrize App');
                }
            );
        }
    };

    checkNewCustomers = () => {
        http.postToServer(
            'customers/check_new',
            {},
            (response) => {
                //console.log(response.data)

                let text = "";

                if(response.data.newCustomer_35.length > 0) {

                    text = "שימו לב יש עסקה של: \n";
                    for (let index in response.data.newCustomer_35) {
                        let name = response.data.newCustomer_35[index].name;
                        let provider = response.data.newCustomer_35[index].provider;

                        text += "לקוח - " + name + "\n";
                        text += "בחברת - " + provider + "\n";
                    }

                    text += "שממתינה מעל 40 דקות\n" +
                        "נא לטפל בה  בהקדם האפשרי";

                    text += '\n\n\n';
                }

                if(response.data.newCustomer_60.length > 0) {

                    text += "שימו לב יש עסקה של: \n";

                    for (let index in response.data.newCustomer_60) {
                        let name = response.data.newCustomer_60[index].name;
                        let provider = response.data.newCustomer_60[index].provider;

                        text += "לקוח - " + name + "\n";
                        text += "בחברת - " + provider + "\n";
                    }

                    text += "שממתינה מעל שעה\n" +
                        "נא לטפל בה  בהקדם האפשרי";
                }

                if(text !== "") {
                    this.setState({newCustomers: text});
                }

            },
            (response) => {
                console.log('error checkNewCustomers');
            }
        );

    };

    closeNewCustomer = () => {
        this.setState({newCustomers: ''});
    };

    render() {
        const loaded = this.state.loaded && !this.props.userData.loading;

        let isManager = false;

        if (this.props.userData && this.props.userData.data && this.props.userData.data.isManager) {
            isManager = true;
        }

        let isAdmin = false;
        if (this.props.userData && this.props.userData.data && this.props.userData.data.isAdmin) {
            isAdmin = true;
        }

        if(this.props.userData && this.props.userData.data) {
            if(managersForNotify.find(e => e.id === this.props.userData.data.id) && !this.state.timerLoaded) {

                setInterval(function(){alert("שלום חברים, לא לשכוח להכנס לבדוק אם יש עסקאות של סטינג ו-yes" + "\n תזכורת..." + "\n שם משתמש: simple" + "\n סיסמה: simple") ;}, 60*60*1000);

                if(isManager) {
                    setInterval(this.checkTasks, 60*60*1000);
                }

                this.setState({timerLoaded: true});
            }
            
            if(!isAdmin && !isManager && !this.state.timerLoaded2) {
                setInterval(this.checkPrize, 3*60*60*1000);

                this.setState({timerLoaded2: true});
            }

            if(environment.ListManagersFeatures.includes(this.props.userData.data.id) && !this.state.timerLoaded3) {
                setInterval(this.checkNewCustomers, 30*60*1000);

                this.setState({timerLoaded3: true});
            }
        }

        return (
            <div>
                {!loaded && <div className={`load${this.state.loading ? '' : ' loaded'}`}>
                    <LoadingProgress/>
                </div>
                }

                {loaded && this.props.status !== USER_NO_PERMISSION &&
                <div>
                    {this.state.newCustomers !== '' && <ModalTrueBigProp color='primary' title="!!!שימו לב" noCancel approve={this.closeNewCustomer}
                                                                     message={this.state.newCustomers}/>}
                    <Router isManager={isManager} isAdmin={isAdmin} hasError={this.props.status === USER_FAILED} userData={this.props.userData}/>
                </div>
                }

                {loaded && this.props.status === USER_NO_PERMISSION &&
                <RouterSignUp/>
                }

            </div>
        );
    }
}

export default withRouter(connect(state => {
    return {
        userData: state.userData,
        status: state.userData.status
    }
})(App));
